// nav_sp
$(function () {
  $("#nav_sp_btn").on("click", function () {
    if ($(this).children(".open").is(":hidden")) {
      $(this).children(".open").fadeIn().css("display", "flex");
      $(this).children(".close").fadeOut();
      $(".nav_sp_list").css("transform", "translateX(-100%)");
    } else {
      $(this).children(".open").fadeOut();
      $(this).children(".close").fadeIn().css("display", "flex");
      $(".nav_sp_list").css("transform", "translateX(0)");
    }
  })
  $(".nav_sp_btn_close").on("click", function () {
    $(".nav_sp_list").css("transform", "translateX(-100%)");
    $("#nav_sp_btn").children(".open").fadeIn().css("display", "flex");
    $("#nav_sp_btn").children(".close").fadeOut();
  })
})
